import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDHeadlineText, FDTextInput,
} from '@facet-wealth/design';
import ButtonPicklist from 'Packages/FacetDesign/Components/Experimental/ButtonPicklist';

export default buildFacetDesignOverride()
  .nameOverride('title',
    {
      _component: () => FDHeadlineText,
      _customProps: { size: 'sm' },
    },
    overrideReadOnly)
  .nameOverride('routingTarget',
    {
      _component: () => ButtonPicklist,
    },
    overrideReadOnly)
  .nameOverride(['newThreadSubject', 'internalNote'],
    {
      _component: () => FDTextInput,
      _customProps: { helperText: '' },
    },
    overrideReadOnly)
  .nameOverride(['newThreadSubjectDescription', 'routingTargetDescription', 'internalNoteDescription'],
    {
      _component: () => FDBodyText,
    },
    overrideReadOnly);
